import React from 'react'
import { useNavigate } from 'react-router-dom'
import TopBarUserDropdown from './TopBarUserDropdown'
import useAppState from '../hooks/useAppState'
import useModalState from '../hooks/useModalState'
import TenantSelectionModalWithState from '../pages/tenant-selection/TenantSelectionModalWithState'

const TopBarUserDropdownWithState = () => {
    const navigate = useNavigate()
    const tenantSelectionModal = useModalState()
    const { logout } = useAppState()

    return (
        <>
            <TopBarUserDropdown
                onClickProfile={() => navigate('/profile')}
                onSwitchTenant={() => tenantSelectionModal.open()}
                onSupport={() => navigate('/support')}
                onLogout={logout}
            />
            {tenantSelectionModal.isOpen && (
                <TenantSelectionModalWithState
                    onClose={() => tenantSelectionModal.close()}
                />
            )}
        </>
    )
}

export default TopBarUserDropdownWithState
